<template>
    <div>
    </div>
  </template>
  
  <script>
  //import api from '../../services/api.js'
  import { API_HOST } from '../../services/constant'
  
  export default {
    name: 'Alipay',
    created () {
      let id=this.$route.params.id
      if(id){
        window.location.href=API_HOST+'/pay/alipay_mobile/pay.php?order_no='+id
        /*api.get(this, {
                path: 'pay/alipay_mobile/pay.php',
                params: {order_no:this.$route.params.id},
        })*/
      }
    },
  }
  </script>
  


// WEBPACK FOOTER //
// src/pages/home/alipay.vue